class CompanyService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/avg/company', params);
  }

  create(params) {
    return this.apiService.post('/api/v1/avg/company', params);
  }

  update(params) {
    return this.apiService.put(`/api/v1/avg/company/${params.id}`, params);
  }

  remove(params) {
    return this.apiService.delete('/api/v1/avg/company', params);
  }
}

export default CompanyService;
